// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/tmp/13bc7d76/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/tmp/13bc7d76/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

